import get from 'lodash/get'

export default function (obj, field, defaultValue) {
  if (typeof field === 'function') {
    let additionalParamsForCallback = [...arguments].slice(3)
    return field(obj, ...additionalParamsForCallback) || defaultValue
  }
  return get(obj, field, defaultValue)
}



// WEBPACK FOOTER //
// ./src/utils/getField.js